import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import styles from '../Dashboards.mod.less';
import Spinner from '../../common/Spinner';
import { useAhaPanelContents, useHtmlSnapshot } from '../hooks';
import TimelineControl from 'components/timeline_control/TimelineControl';
import AhaContents from './AhaContents';
import customElementBoolAttr from 'javascripts/util/customElementBoolAttr';

const Timeline = ({ panel, preview, bookmarkId, filters }) => {
  const ahaContents = useAhaPanelContents({
    panel,
    bookmarkId,
    preview,
    dashboardFilter: panel.dashboardFilter,
    showLegend: panel.showLegend,
    filters,
  });
  const [timelineProps, setTimelineProps] = useState(null);
  const [timelineWrapper, setTimelineWrapper] = useState(null);
  const panelContentRef = useRef(null);
  const shouldUseHtmlSnapshot = useHtmlSnapshot();

  useEffect(() => {
    let timelineWrapper;
    if ((ahaContents || shouldUseHtmlSnapshot) && panelContentRef.current) {
      timelineWrapper = panelContentRef.current.getElementsByClassName(
        'relative-publish-pivot-wrapper'
      )[0];
      if (timelineWrapper) {
        // clear the innerHTML. even if there is html already pre-rendered,
        // we want the TimelineControl to go through the full mount cycle so
        // it can initialize the resize handlers it needs. If this innerHTML
        // is not cleared out, it will result in the timeline chart essentially
        // appearing twice.
        timelineWrapper.innerHTML = '';
        const propsJson = timelineWrapper.getAttribute('data-json');
        const props = propsJson ? JSON.parse(propsJson) : {};
        setTimelineProps(props);
        setTimelineWrapper(timelineWrapper);
      }
    }
  }, [ahaContents, panelContentRef, shouldUseHtmlSnapshot]);

  let panelContent;
  if (ahaContents || shouldUseHtmlSnapshot) {
    panelContent = <AhaContents ahaContents={ahaContents} />;
  } else {
    panelContent = <Spinner />;
  }

  let timeline;
  if (timelineWrapper && timelineProps) {
    timeline = ReactDOM.createPortal(
      <TimelineControl {...timelineProps} />,
      timelineWrapper
    );
  }

  const isLoading = !ahaContents && !shouldUseHtmlSnapshot;

  return (
    <div
      className={styles.PanelContent}
      ref={panelContentRef}
      data-async-loading={customElementBoolAttr(isLoading)}
    >
      {panelContent}
      {timeline}
    </div>
  );
};

const mapStateToProps = state => ({
  bookmarkId: state.getIn(['meta', 'bookmarkId']),
  filters: state.getIn(['meta', 'filters']),
});

export default connect(mapStateToProps)(Timeline);
